import { infoWindowContent } from '../singleOfferInfowindow';
import { IMultipleOfferInfoWindow } from '../../types';
import { InfowindowBuilder } from '../../../../../shared/utils/infowindowBuilder';
import indowWindowStyles from '../../../../../shared/styles/infowindow.style';

const leftArrow = `
  <svg style="transform: rotate(180deg)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M4.34065 10.8292L13.649 10.8292L9.58232 14.8958C9.25732 15.2208 9.25732 15.7542 9.58232 16.0792C9.90732 16.4042 10.4323 16.4042 10.7573 16.0792L16.249 10.5875C16.574 10.2625 16.574 9.73749 16.249 9.41249L10.7573 3.92082C10.4323 3.59582 9.90732 3.59582 9.58232 3.92082C9.25732 4.24582 9.25732 4.77082 9.58232 5.09582L13.649 9.16249L4.34065 9.16249C3.88232 9.16249 3.50732 9.53749 3.50732 9.99582C3.50732 10.4542 3.88232 10.8292 4.34065 10.8292Z" fill="currentColor"/>
  </svg>
`;
const rightArrow = `
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M4.34065 10.8292L13.649 10.8292L9.58232 14.8958C9.25732 15.2208 9.25732 15.7542 9.58232 16.0792C9.90732 16.4042 10.4323 16.4042 10.7573 16.0792L16.249 10.5875C16.574 10.2625 16.574 9.73749 16.249 9.41249L10.7573 3.92082C10.4323 3.59582 9.90732 3.59582 9.58232 3.92082C9.25732 4.24582 9.25732 4.77082 9.58232 5.09582L13.649 9.16249L4.34065 9.16249C3.88232 9.16249 3.50732 9.53749 3.50732 9.99582C3.50732 10.4542 3.88232 10.8292 4.34065 10.8292Z" fill="currentColor"/>
  </svg>
`;

const multipleOffersInfowindow = (
  info: IMultipleOfferInfoWindow & { index: number; actions: any }
): InfowindowBuilder => {
  const currentOffer = info.index + 1;
  const totalOffers = (info.marker as google.maps.Marker[]).length;

  const isPreviusButtonDisabled = currentOffer === 1;
  const isNextButtonDisabled = currentOffer === totalOffers;
  const content = infoWindowContent(info);
  content.buildHeader(`
  <h6 class="header--title" data-cy="IWBuildingName">Anúncios encontrados</h6>
  <div class="header--actions">
    <div>
      <button ${
        isPreviusButtonDisabled ? 'disabled' : ''
      } id="PreviousButton" class="header--actions--arrow" data-cy="IWPrevious">
        ${leftArrow}
      </button>
    </div>
    <div>(${currentOffer}/${totalOffers})</div>
    <div>
      <button ${
        isNextButtonDisabled ? 'disabled' : ''
      } id="NextButton" class="header--actions--arrow" data-cy="IWNext">
      ${rightArrow}
      </button>
    </div>
  </div>
  `);

  const style = `
  ${indowWindowStyles}\n
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding-right: 52px;
  }
  .header--actions {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    justify-items: center;

    gap: 4px;
    width: 60px;
  }
  .header--actions div {
    font: 700 14px/18px'Open Sans', sans-serif;
    height: 20px;
  }
  .header--actions--arrow {
    width: 20px;
    height: 20px;
    border-radius: 50%;

    padding: 0;
    border: none;

    background-color: #793EAD;

    color: #fff;

    cursor: pointer;
  }
  .header--actions--arrow:hover {
    transition: 0.2s;
    background-color: #3F205A;
  }
  .header--actions--arrow:disabled {
    background-color: transparent;
      cursor: not-allowed;
  }
  .header--actions--arrow:disabled svg {
    color: #E5E5E5;
  }
  .header--actions--arrow svg {
    pointer-events: none;
  }
  `;

  const markers = info.marker as google.maps.Marker[];

  return new InfowindowBuilder({
    content: Array(markers.length).fill(content),
    marker: markers[0],
    map: info.map,
    style,
    index: info.index,
    actions: info.actions,
  });
};

export default multipleOffersInfowindow;
